function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import { RIGHT_ALIGNED_HEADER_TEMPLATE } from 'invision-ui/lib/components/collections/datatable/cellTemplates/cellTemplates';
import LocaleKeys from '../../../../locales/keys';
import { MetadataCodeLoadedSelector, MetadataCodeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { fetchCodeTypes, fetchCodeTypesThunk } from 'invision-core/src/components/metadata/codes/codes.actions';
import { BusinessUnitSelectors, DateRangeShortcutHelper, i18n, PermissionService, SessionSelectors } from 'invision-core';
import { CurrentCustomerIdSelector, CurrentCustomerSelector, IsCurrentCustomerBlocklisted, RouteParams } from '../../../../reducers/selectors/customer.selectors';
import { EndRecordSelector, GroupOrderFeatureVisibilitySelector, IsFetchingOrdersSelector, RecordCountSelector, StartRecordSelector, TableDataSelector, TotalPagesSelector } from '../../../../reducers/selectors/order.history.selectors';
import { autoOrdersFilterSelector, endDateSelector, migratedOrdersFilterSelector, orderKindsFiltersSelector, pageNumberSelector, SelectedPageSizePreferenceSelector, selectedStatusFilterSelector, selectedTypeFilterSelector, startDateSelector } from '../../../../reducers/selectors/order.history.filter.selectors';
import * as OrderHistoryActions from '../../../../reducers/actions/order.history.actions';
import * as OrderHistoryFilterActions from '../../../../reducers/actions/order.history.filter.actions';
import { STATE_OR_NAME as ADD_OFFER_STATE } from '../../../../reducers/constants/add.offer.wizard.constants';
import { CREATE_PRODUCTS_ORDER_STATE_NAME as NEW_PRODUCT_ORDER_STATE } from '../../../../reducers/constants/products.wizard.constants';
import { ORDERING_ACCESS } from '../../../../security.attributes';
var OrderHistoryListController = /*#__PURE__*/function () {
  function OrderHistoryListController($ngRedux) {
    _classCallCheck(this, OrderHistoryListController);
    this.$ngRedux = $ngRedux;
  }
  return _createClass(OrderHistoryListController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var columnDefs = [{
        field: 'OrderNumber',
        displayName: i18n.translate(LocaleKeys.ORDER_HISTORY.COLUMNS.ORDER),
        width: '10%',
        cellTemplate: require('../cellTemplates/order.number.template.html')
      }, {
        field: 'OrderName',
        displayName: i18n.translate(LocaleKeys.ORDER_HISTORY.COLUMNS.ORDER_DESCRIPTION),
        width: '23%',
        minWidth: 200
      }, {
        field: 'OrderStatus',
        displayName: i18n.translate(LocaleKeys.ORDER_HISTORY.COLUMNS.ORDER_STATUS_NAME),
        width: '10%',
        cellTemplate: require('../cellTemplates/order.status.template.html')
      }, {
        field: 'OrderTypeName',
        displayName: i18n.translate(LocaleKeys.ORDER_HISTORY.COLUMNS.ORDER_TYPE),
        width: '14%',
        minWidth: 100
      }, {
        field: 'OrderReasonValue',
        displayName: i18n.translate(LocaleKeys.ORDER_DETAILS.ORDER_REASON),
        width: '21%',
        minWidth: 100,
        cellTemplate: require('../cellTemplates/order.reason.template.html')
      }, {
        field: 'Ordered',
        displayName: i18n.translate(LocaleKeys.ORDER_HISTORY.COLUMNS.ORDER_DATE),
        width: '12%',
        minWidth: 80,
        cellTemplate: require('../cellTemplates/order.date.template.html')
      }, {
        field: 'TotalAmount',
        displayName: i18n.translate(LocaleKeys.ORDER_HISTORY.COLUMNS.TOTAL_AMOUNT),
        headerCellClass: 'u-pr++',
        headerCellTemplate: RIGHT_ALIGNED_HEADER_TEMPLATE,
        width: '10%',
        cellTemplate: require('../cellTemplates/total.amount.template.html')
      }];
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          autoOrdersFilter: autoOrdersFilterSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          endDate: endDateSelector(store),
          endRecord: EndRecordSelector(store),
          isCurrentCustomerBlocklisted: IsCurrentCustomerBlocklisted(store),
          isDbss: BusinessUnitSelectors.IsDbss(store),
          isFetchingOrders: IsFetchingOrdersSelector(store),
          isServiceReasonCodeLoaded: MetadataCodeLoadedSelector(CODES.ReasonCodes, store),
          maximumSlots: 5,
          migratedOrdersFilter: migratedOrdersFilterSelector(store),
          numberOfPages: TotalPagesSelector(store),
          orderKindsFilterOptions: orderKindsFiltersSelector(store),
          orderStatuses: MetadataCodeSelector(CODES.OrderStatus, store),
          orderStatusLoaded: MetadataCodeLoadedSelector(CODES.OrderStatus, store),
          pageNumber: pageNumberSelector(store),
          recordCount: RecordCountSelector(store),
          routeParams: RouteParams(store),
          selectedPageSizePreference: SelectedPageSizePreferenceSelector(store),
          selectedOrderStatuses: selectedStatusFilterSelector(store),
          selectedOrderTypes: selectedTypeFilterSelector(store),
          startDate: startDateSelector(store),
          startRecord: StartRecordSelector(store),
          tableData: {
            enableSorting: false,
            columnDefs: columnDefs,
            data: TableDataSelector(store)
          },
          userPageSizePreference: SessionSelectors.PageSizePreferenceSelector(store),
          userSecurityAttributes: SessionSelectors.UserSecurityAttributesSelector(store),
          isFeatureToggleCodesLoaded: MetadataCodeLoadedSelector(CODES.FeatureToggleConfig, store),
          isGroupOrderEnabled: GroupOrderFeatureVisibilitySelector(store)
        };
      };
      var controllerActions = {
        fetchDisconnectReasons: function fetchDisconnectReasons() {
          return fetchCodeTypes(CODES.ReasonCodes);
        },
        fetchCodeTypesThunk: fetchCodeTypesThunk,
        searchOrders: OrderHistoryActions.searchOrders,
        setPageSizePreference: OrderHistoryFilterActions.updatePageSizePreference,
        stateGo: stateGo,
        updateDateRange: OrderHistoryFilterActions.updateDateRange,
        updateKindFilter: OrderHistoryFilterActions.updateOrderKindFilter,
        updatePageNumber: OrderHistoryFilterActions.updatePageNumber,
        updatePageSizePreference: OrderHistoryFilterActions.updatePageSizePreference,
        updateStatusFilter: OrderHistoryFilterActions.updateOrderStatusFilter,
        updateTypeFilter: OrderHistoryFilterActions.updateOrderTypeFilter
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.isServiceReasonCodeLoaded) {
        this.actions.fetchDisconnectReasons();
      }
      if (!this.state.isFeatureToggleCodesLoaded) {
        this.actions.fetchCodeTypesThunk(CODES.FeatureToggleConfig);
      }
      /**This logic is added for when we redirect from Open orders account status widget in react
       * We want to land on the order history list page with only open orders and pending orders filtered in the list page
       */
      if (!this.state.orderStatusLoaded && this.state.routeParams.statusFilters) {
        this.actions.fetchCodeTypesThunk(CODES.OrderStatus).then(function (orderStatuses) {
          _this.setupStatusFilter(orderStatuses.Codes);
        });
      }
      if (this.state.routeParams.statusFilters && this.state.orderStatusLoaded) {
        this.setupStatusFilter(this.state.orderStatuses.items);
      }
      this.updatePage = function (page) {
        _this.actions.updatePageNumber(page);
        _this.searchOrders();
      };
      this.updateTypeFilter = function (selected) {
        _this.actions.updatePageNumber(1);
        _this.actions.updateTypeFilter(selected);
        _this.searchOrders();
      };
      this.updateIncludeKindFilter = function (selected) {
        _this.actions.updatePageNumber(1);
        _this.actions.updateKindFilter(selected);
        _this.searchOrders();
      };
      this.onDateRangeChanged = function (start, end) {
        _this.actions.updatePageNumber(1);
        _this.actions.updateDateRange({
          startDate: start,
          endDate: end
        });
        _this.searchOrders();
      };
      this.showDisabledNewOrderButton = function () {
        return _this.state.isDbss && !_this.state.currentCustomer.ConvergentBillerId || _this.state.isCurrentCustomerBlocklisted;
      };
      this.handleClickCreateOrder = function () {
        if (!_this.showDisabledNewOrderButton()) {
          _this.actions.stateGo(_this.state.isDbss ? ADD_OFFER_STATE : NEW_PRODUCT_ORDER_STATE);
        }
      };
      this.hasOrderingAccess = function () {
        return PermissionService.hasAdminAccess(_this.state.userSecurityAttributes, ORDERING_ACCESS);
      };
      var entireHistoryDateShortcut = DateRangeShortcutHelper.getNullableOption(i18n.translate(LocaleKeys.ALL_TIME));
      this.dateShortcuts = [[entireHistoryDateShortcut].concat(DateRangeShortcutHelper.getShortListShortcuts()), DateRangeShortcutHelper.getRelativeShortListShortcuts()];
      this.selectedDateShortcut = entireHistoryDateShortcut;
      this.CustomerLocaleKeys = LocaleKeys;
      this.stateOrName = 'index.customercare.customer.orderHistory';
      this.optionalParams = {
        customerId: this.state.currentCustomerId
      };
      this.searchOrders();
    }
  }, {
    key: "disabledNewOrderButtonTooltip",
    get: function get() {
      if (this.state.isCurrentCustomerBlocklisted) {
        return this.CustomerLocaleKeys.CUSTOMER_DASHBOARD.ACCOUNT_STATUS_BLOCKLISTED_LOCKED_ORDERING;
      } else {
        return this.CustomerLocaleKeys.CUSTOMER_DASHBOARD.CONVERGENT_BILLER_ERROR;
      }
    }
    /**This logic is added for when we redirect from Open orders account status widget in react
    * We want to land on the order history list page with only open orders and pending orders filtered in the list page
    */
  }, {
    key: "setupStatusFilter",
    value: function setupStatusFilter(items) {
      var statusFilters = this.state.routeParams.statusFilters.split(',');
      var filters = (items || []).filter(function (item) {
        return statusFilters.includes(item.Value);
      });
      filters.forEach(function (status) {
        status.id = status.Value;
      });
      this.updateStatusFilter(filters);
    }
  }, {
    key: "searchOrders",
    value: function searchOrders() {
      if (!this.state.selectedPageSizePreference) {
        this.actions.setPageSizePreference(this.state.userPageSizePreference);
      }
      var filters = {
        pageSize: this.state.selectedPageSizePreference,
        pageNumber: this.state.pageNumber,
        orderStatus: this.state.selectedOrderStatuses,
        orderType: this.state.selectedOrderTypes,
        returnAutoOrders: this.state.autoOrdersFilter && this.state.autoOrdersFilter.selected,
        returnMigratedOrders: this.state.migratedOrdersFilter && this.state.migratedOrdersFilter.selected,
        startDate: this.state.startDate,
        endDate: this.state.endDate
      };
      this.actions.searchOrders(this.state.currentCustomerId, filters);
    }
  }, {
    key: "updateStatusFilter",
    value: function updateStatusFilter(selected) {
      this.actions.updatePageNumber(1);
      this.actions.updateStatusFilter(selected);
      this.searchOrders();
    }
  }, {
    key: "onPageSizeOptionsSelected",
    value: function onPageSizeOptionsSelected(pageSize) {
      this.actions.setPageSizePreference(pageSize);
      this.updatePage(1);
    }
  }]);
}();
export default {
  bindings: {},
  controller: OrderHistoryListController,
  controllerAs: 'OrderHistory',
  template: require('./order.history.list.html')
};